import PropTypes from 'prop-types';
import React from 'react';
import { get as _get } from 'lodash';
import ContestNav from '../ContestNav';
import contestPropType from '../../propTypes/contest';

const Contests = ({ children, contest, period, region, showLogo }) => {
  const bgImage = _get(contest, 'meta.acf.background_image', null);
  const bgColor = _get(contest, 'meta.acf.background_color', null);
  const contestStyles = {
    backgroundImage: bgImage ? `url(${bgImage})` : null,
    backgroundColor: bgColor || null,
  };
  return (
    <div className="sl-contest" style={contestStyles}>
      <ContestNav contest={contest} region={region} period={period} showLogo={showLogo} />
      <div className="sl-contest-container">{children}</div>
    </div>
  );
};

Contests.propTypes = {
  children: PropTypes.node.isRequired,
  contest: contestPropType.isRequired,
  period: PropTypes.string,
  region: PropTypes.string,
  showLogo: PropTypes.bool,
};

Contests.defaultProps = {
  period: null,
  region: null,
  showLogo: true,
};

export default Contests;
